import ptBr from './pt_br/pt-br'

export default {
  default: 'pt_br',
  pt_br: ptBr
}



// WEBPACK FOOTER //
// ./src/translate/index.js